import React, { Component } from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem, Button, Collapse } from 'reactstrap';

import { Result } from './Result';
import SearchInput from './SearchInput';
import Logo from './ui-elements/Logo';
import { CheckFilter, RangeFilter } from './ui-elements/Filter';
import Loading from './ui-elements/Loading';
import NoResults from './ui-elements/NoResults';


class SortBy extends Component {
  handleClick = (type) => {
    if(this.props.sort_by !== type){
      this.props.handleClick(type);
    }
  }
  render(){
    return (
      <div className="filterList rounded-top mb-0 mb-sm-3" style={{ overflow: 'hidden' }}>
        <ListGroupItem className="text-left d-flex justify-content-between border-0 action" onClick={this.props.toggle}>
          <h6><i className="fas fa-sort mr-2"></i>Sortieren nach</h6><i className={this.props.isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}></i>
        </ListGroupItem>
        <Collapse isOpen={this.props.isOpen}>

          <ListGroupItem className="text-left border-0 py-0">
            <Button color="link" className={ (this.props.sort_by==='year_desc' && 'font-weight-bold')+" text-body px-0 m-0" } onClick={() => this.handleClick('year_desc') }>Datum (neueste zuerst)</Button>
          </ListGroupItem>
          <ListGroupItem className="text-left border-0 py-0">
            <Button color="link" className={ (this.props.sort_by==='year_asc' && 'font-weight-bold')+" text-body px-0 m-0" } onClick={() => this.handleClick('year_asc') }>Datum (älteste zuerst)</Button>
          </ListGroupItem>

          <ListGroupItem className="text-left border-0 py-0">
            <Button color="link" className={ (this.props.sort_by==='num_pages_desc' && 'font-weight-bold')+" text-body px-0 m-0" } onClick={() => this.handleClick('num_pages_desc') }>Seitenanzahl (absteigend)</Button>
          </ListGroupItem>
          <ListGroupItem className="text-left border-0 py-0">
            <Button color="link" className={ (this.props.sort_by==='num_pages_asc' && 'font-weight-bold')+" text-body px-0 m-0" } onClick={() => this.handleClick('num_pages_asc') }>Seitenanzahl (aufsteigend)</Button>
          </ListGroupItem>

        </Collapse>
      </div>
    )
  }
}


class FilterBy extends Component {
  render(){
    return (
      <React.Fragment>

        <div className="d-block d-sm-none rounded-bottom border-top border-light filterList mb-3 mb-sm-0" style={{ overflow: 'hidden' }}>
          <ListGroupItem className="text-left d-flex justify-content-between border-0 rounded-top action" onClick={this.props.toggle}>
            <h6><i className="fas fa-check-square mr-2"></i>Filtern nach</h6><i className={this.props.isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}></i>
          </ListGroupItem>
        </div>

        <Collapse isOpen={this.props.isOpen}>
          <div className="filterList rounded mb-3" style={{ overflow: 'hidden' }}>
            <ListGroup>
              <CheckFilter
                name="Organisation"
                field="organisation"
                items={ Object.keys(this.props.results.aggs.full.organisations) }
                isOpen={true}
                handleChange={this.props.toggleFilter}
                query={this.props.query}
                results={this.props.hits}
                groupBy={ this.props.results.aggs.full.org_types }
              />
              <RangeFilter
                name="Erscheinungsjahr"
                field="year"
                items={this.props.results.aggs.full.years}
                filteredItems={this.props.results.aggs.filtered.years}
                handleChange={this.props.toggleFilter}
                query={this.props.query}
                tooltipString={'%label: %value Ergebnisse'}
              />
              <RangeFilter
                name="Seitenanzahl"
                field="num_pages"
                items={this.props.results.aggs.full.num_pages}
                filteredItems={this.props.results.aggs.filtered.num_pages}
                handleChange={this.props.toggleFilter}
                query={this.props.query}
                tooltipString={'%label Seiten: %value Ergebnisse'}
              />
              <CheckFilter
                name="Sprache"
                field="language"
                items={ Object.keys(this.props.results.aggs.full.languages) }
                isOpen={false}
                handleChange={this.props.toggleFilter}
                query={this.props.query}
                results={this.props.hits}
                liStyle={{ textTransform: 'uppercase' }}
              />
            </ListGroup>
          </div>
        </Collapse>
      </React.Fragment>
    )
  }
}



/*
<ListGroupItem className="text-left border-0 py-0">
  <Button color="link" className={ (this.props.sort_by==='' && 'font-weight-bold')+" text-body px-0 m-0" } onClick={() => this.handleClick('') }>Relevanz</Button>
</ListGroupItem>
*/

class SearchList extends Component {

  constructor(props){
    super(props);
    this.state = {
      filterByIsOpen: true,
      sortByIsOpen: false,
      windowWidth: 0,
      windowHeight: 0,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    }, () => {
      if(this.state.windowWidth < 576){
        this.setState({
          filterByIsOpen: false,
        });
      } else {
        this.setState({
          filterByIsOpen: true,
        });
      }
    });
  }

  toggleFilterBy = () => {
    this.setState({
      filterByIsOpen: !this.state.filterByIsOpen
    })
  }
  toggleSortBy = () => {
    this.setState({
      sortByIsOpen: !this.state.sortByIsOpen
    })
  }

  renderLoadMoreButton = (results) => {
    if(results.length < this.props.results.aggs.filtered.hits_total){
      if(!this.props.loadingMore){
        return <Button color="dark" outline block className="mt-3 mb-5" onClick={this.props.loadMoreResults}>Weitere Ergebnisse</Button>
      } else {
        return <Loading />
      }
    }
  }

  renderResults = (results) => {
    if(!this.props.loading){
      return results.map(function(result, index){
        return <React.Fragment key={result.id}>
          <Result lecture={result} />
          { ((index+1)%20===0 && results.length>index+1 && <hr />) }
        </React.Fragment>;
      })
    } else {
      return <Loading />
    }
  }

  render() {

    const hits = this.props.results.hits;

    return (
      <Container className={ ( (hits && hits.length > 0) ? ' mx-0' : 'mx-auto' ) + this.props.className + ' my-3'}>
        <Row>
          <Col xs="12" md="6" className="text-center mx-auto mb-0 mb-md-4 pb-4 pt-0 pt-sm-4">
            <Logo size="lg" className='mb-3 mb-sm-4'/>
            <SearchInput className="shadow-sm" style={{}}/>
          </Col>
        </Row>
        <Row>

          {hits ?
            <React.Fragment>

                  <Col xs="12" className="text-center mb-3 mb-sm-4">
                    <small className="d-block text-muted mb-1">Die Suche nach <strong>{this.props.query}</strong> ergab insgesamt <strong>{this.props.results.aggs.full.hits_total} Ergebnisse</strong></small>
                    { this.props.results.aggs.full.hits_total !== this.props.results.aggs.filtered.hits_total && <small className="d-block text-secondary mb-1"><strong>{this.props.results.aggs.filtered.hits_total} Ergebnisse</strong> mit den gewählten Filtern.</small> }
                  </Col>

                  <Col xs="12" md="4">
                    <div className="sticky-top" id="filterColumn">
                      <SortBy
                        {...this.props}
                        {...this.state}
                        handleClick={this.props.changeOrder}
                        isOpen={this.state.sortByIsOpen}
                        toggle={this.toggleSortBy}
                      />
                      <FilterBy
                        {...this.props}
                        hits={hits}
                        isOpen={this.state.filterByIsOpen}
                        toggle={this.toggleFilterBy}
                      />
                    </div>
                  </Col>

                  { hits.length > 0 ?
                    <Col xs="12" md="8">
                    { this.renderResults(hits) }
                    { this.renderLoadMoreButton(hits) }
                    </Col>
                  :
                    <Col xs="12" md="8" className="mx-auto">
                      <NoResults />
                    </Col>
                  }

            </React.Fragment>
            : <Loading />
          }

        </Row>
      </Container>
    )
  }
}

export default SearchList;



// WEBPACK FOOTER //
// ./src/components/SearchList.js